import { render, staticRenderFns } from "./paymentSuccess2.vue?vue&type=template&id=0c0f6e3e&scoped=true"
import script from "./paymentSuccess2.vue?vue&type=script&lang=js"
export * from "./paymentSuccess2.vue?vue&type=script&lang=js"
import style0 from "./paymentSuccess2.vue?vue&type=style&index=0&id=0c0f6e3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f6e3e",
  null
  
)

export default component.exports